function getVersion() {
  const version = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  return version ? parseInt(version[2], 10) : false;
}

export default getVersion;
